import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface TransactionCodesReportParams {
  format?: string;
  totalDays: number;
}

export const transactionCodesReportAPI = async (
  params: TransactionCodesReportParams,
) => {
  const response = await baseAPI.get<string>(
    'reporting/transaction-codes-report',
    {
      params,
      responseType: 'text',
    },
  );
  return response.data;
};

export const useTransactionCodesReport = (
  params: TransactionCodesReportParams,
) => {
  return useQuery({
    queryKey: [
      KEYS.TRANSACTION_CODES_REPORT,
      Number(params.totalDays),
      params.format ?? 'csv',
    ],
    queryFn: () => transactionCodesReportAPI(params),
    enabled: !!params.totalDays,
  });
};
